var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68392 1.60261C2.59728 1.57744 2.50544 1.57619 2.41814 1.59898C2.33084 1.62177 2.25134 1.66775 2.18805 1.73206C2.12477 1.79637 2.08006 1.87661 2.05868 1.96426C2.0373 2.05191 2.04003 2.14372 2.06659 2.22995L3.68792 7.49995H9.36525C9.49786 7.49995 9.62504 7.55263 9.71881 7.64639C9.81258 7.74016 9.86525 7.86734 9.86525 7.99995C9.86525 8.13256 9.81258 8.25973 9.71881 8.3535C9.62504 8.44727 9.49786 8.49995 9.36525 8.49995H3.68792L2.06659 13.7699C2.04019 13.8561 2.03757 13.9479 2.05903 14.0354C2.08048 14.123 2.1252 14.2031 2.18846 14.2673C2.25172 14.3315 2.33116 14.3774 2.41838 14.4002C2.5056 14.423 2.59735 14.4217 2.68392 14.3966C7.0939 13.1142 11.2525 11.0882 14.9806 8.40595C15.045 8.35964 15.0975 8.29867 15.1337 8.22808C15.1699 8.15748 15.1888 8.07928 15.1888 7.99995C15.1888 7.92061 15.1699 7.84242 15.1337 7.77182C15.0975 7.70122 15.045 7.64025 14.9806 7.59395C11.2526 4.91148 7.09395 2.88525 2.68392 1.60261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.e1c54098b8f6b49f44b45deaaa77d0af.svg";
export { ForwardRef as ReactComponent };